import { Navigate, useParams } from 'react-router';

/**
 * `/flags/:key` → `/catalog/flags/:key`.
 *
 * A bare `<Navigate>` cannot do this: the key has to be read from the old URL
 * and put back into the new one, or every saved link to a specific flag would
 * land on the list instead of the flag.
 *
 * `useParams` returns the key already decoded, and `Navigate` encodes what it
 * is given, so a key containing a `.` or a `/` survives the round trip rather
 * than being encoded twice.
 */
export function LegacyFlagRedirect() {
    const { key } = useParams();

    return (
        <Navigate
            to={key === undefined ? '/catalog/flags' : `/catalog/flags/${encodeURIComponent(key)}`}
            replace
        />
    );
}
